import { ApiService, ApiServiceGetResponse } from '@services'
import { UserReferralsItem, UserReferralsRewardItem } from '@store'

export const getUserReferralsApi = async (): Promise<
  ApiServiceGetResponse<{
    referrals: UserReferralsItem[]
    rewards: UserReferralsRewardItem[]
    rating_for_referrals: number
  }>
> => {
  const { ok, data } = await ApiService.get({
    endpoint: '/api/v1/user/referrals',
  })

  return { ok, data: data || null }
}

export const claimReferralRewardApi = async (
  milestone_id: number
): Promise<ApiServiceGetResponse<any>> => {
  const { ok, data } = await ApiService.post({
    endpoint: `/api/v1/user/referrals/claim/${milestone_id}`,
  })

  return { ok, data: data || null }
}
